import { computed, makeObservable } from 'mobx';
import moment from 'moment';
import { bpmsResourcesManagerApi, licenseApi } from 'src/services/apiServices';
import { BasicStore } from 'src/utils/mobx/BasicStore/BasicStore';
import { BasicStoreApi } from 'src/utils/mobx/BasicStore/BasicStore.types';
import { RequestHelper } from 'src/utils/RequestHelper';

const DAYS_BEFORE_LICENSE_EXPIRATION_TO_SHOW_WARNING = 30;

export class SettingsLicenseStoreClass extends BasicStore<any> {
    constructor() {
        super();
        makeObservable(this);
    }

    itemDetailsFormKey = 'embedded:deployment:forms/bo/bo-60-license.json';

    itemEditFormKey = '';

    api: BasicStoreApi<any> = {
        loadItemForm: (formKey: string, ...args) => {
            const options = RequestHelper.getOptionsFromArgs(args);

            return RequestHelper.unwrapFromAxiosPromise(
                bpmsResourcesManagerApi.getForm({ formKey }, options),
            );
        },
        loadItem: (...args) => {
            const options = RequestHelper.getOptionsFromArgs(args);

            return RequestHelper.unwrapFromAxiosPromise(
                licenseApi.getLicenseInfo(options),
            );
        },
        updateItem: (_, data, ...args) => {
            const options = RequestHelper.getOptionsFromArgs(args);

            return RequestHelper.unwrapFromAxiosPromise(
                licenseApi.activateLicense(
                    { licenseActivationRequest: data },
                    options,
                ),
            );
        },
    };

    @computed get isLicenseExpiring(): boolean {
        const licenseInfo = this.currentItem?.activeLicenseInfo;

        if (!licenseInfo || !licenseInfo.expiryDate) {
            return false;
        }

        const expirationDate = moment(licenseInfo.expiryDate);
        const now = moment();
        const warningThresholdDate = moment().add(
            DAYS_BEFORE_LICENSE_EXPIRATION_TO_SHOW_WARNING,
            'days',
        );

        return (
            expirationDate.isValid() &&
            expirationDate.isAfter(now) &&
            expirationDate.isSameOrBefore(warningThresholdDate)
        );
    }

    @computed get licenseExpirationDate() {
        return this.currentItem?.activeLicenseInfo?.expiryDate;
    }
}

export const SettingsLicenseStore = new SettingsLicenseStoreClass();
